import { render, staticRenderFns } from "./PropertyNode.vue?vue&type=template&id=515aa3aa&scoped=true&lang=pug&"
import script from "./PropertyNode.vue?vue&type=script&lang=ts&"
export * from "./PropertyNode.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyNode.vue?vue&type=style&index=0&id=515aa3aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515aa3aa",
  null
  
)

export default component.exports